import {FC, useEffect} from "react";
import {Tabs} from "antd";
import styles from './AdminPage.module.css';
import {UsersTab} from "./components/UsersTab/UsersTab.tsx";
import {useOwnProfile} from "../../stores/OwnProfileStore.ts";
import {useNavigate} from "react-router";
import {InvitesTab} from "./components/InvitesTab/InvitesTab.tsx";

export const AdminPage: FC = () => {
    const { profile } = useOwnProfile();

    const navigate = useNavigate();
    useEffect(() => {
        if(!profile) return;
        if(!profile.admin && profile.role !== 'staff') navigate('/');
    }, [profile]);

    return (
        <Tabs
            items={[
                {
                    key: 'users',
                    label: 'Пользователи',
                    children: <UsersTab />
                },
                {
                    key: 'invited',
                    label: 'Приглашения',
                    children: <InvitesTab />
                }
            ]}
            defaultActiveKey="users"
            className={styles.tabs}
        />
    )
}